import { graphClient } from '../graph-client'
import { CREATE_GAME_GOLD_MINER } from './gql'
import type { CreateGoldMiner } from './types'

class GameLuckService {
  async createGoldMiner(params: CreateGoldMiner.Input) {
    const request = await graphClient.request<CreateGoldMiner.Output>(
      CREATE_GAME_GOLD_MINER,
      params,
    )

    return request?.createGameGoldMiner
  }
}

export const gameLuckService = new GameLuckService()
